import { CandidateStatus } from "@/api/candidate/dto/candidate-status.enum";
import { CandidateBasicDtoClient } from "@/api/candidate/dto/candidate.dto";
import { ExamResultStatus } from "@/api/enums/exam-result-status.enum";
import { Badge } from "@/components/atoms/Badge";

interface StatusBadgeProps {
  basicInfo: CandidateBasicDtoClient;
}

const CandidateStatusBadge = ({ basicInfo }: StatusBadgeProps) => {
  let status = null;

  if (
    basicInfo.onGoingRegistrationPerimeter &&
    basicInfo.ongoingRegistrationExamResult !== ExamResultStatus.FAILED &&
    basicInfo.ongoingRegistrationExamResult !== ExamResultStatus.MISSING
  ) {
    if (basicInfo.ongoingRegistrationExamResult === ExamResultStatus.PASSED) {
      status = CandidateStatus.Valid;
    } else {
      status = CandidateStatus.OnGoing;
    }
  } else if (
    basicInfo.lastCertificate &&
    new Date(basicInfo.lastCertificate.expirationDate) >= new Date()
  )
    status = CandidateStatus.Valid;
  else status = CandidateStatus.Expired;

  switch (status) {
    case CandidateStatus.Expired:
      return <Badge variant="white">Expiré</Badge>;
    case CandidateStatus.OnGoing:
      return <Badge variant="orange">En cours</Badge>;
    case CandidateStatus.Valid:
      return <Badge variant="green">Valide</Badge>;
  }
};

export default CandidateStatusBadge;
